import React, { useState, useEffect } from 'react';
import {
    Button,
    Form,
    Input,
    Col,
    Row,
    Flex,
    Select,
    InputNumber,
    Switch,
} from 'antd';
import * as adminactions from "store/actions/AuthActions";
import { CKEditor } from 'ckeditor4-react';
import axios from 'axios';
import { compactToolbar } from "utilities/config";
import { DISCOUNT_TYPE_OPTIONS, discountedLineTotal } from "utilities/discount";


const InvoiceServiceForm = ({ inventoryId, serviceData, setServiceData, taxRates, instance, form, reload }) => {

    const [services, setServices] = useState([]);
    const [serviceDescription, setServiceDescription] = useState("<p>Create your Template here!</p>")
    const [isFixedRate, setIsFixedRate] = useState(false);
    const [taxRate1, setTaxRate1] = useState(0);
    const [taxRate2, setTaxRate2] = useState(0);
    const [taxRate3, setTaxRate3] = useState(0);

    // Fix double-slash issue: REACT_APP_BASE_URL ends with '/'
    const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');
    const editorConfig = {
        extraPlugins: ["tableresize", "uploadimage", "createpdf"],
        removePlugins: [
            "exportpdf",
            "forms",
            "smiley",
            "language",
            "iframe",
            "about",
        ],
        filebrowserImageUploadUrl: `${baseUrl}/template/upload_template_image/`,
        fileTools_requestHeaders: axios.defaults.headers.common,
        uploadUrl: `${baseUrl}/template/upload_template_image/`,
        contentsCss: [`${baseUrl}/staticfiles/ckeditor/4.19.0/full-all/document-style.css`, "/ckeditor-content.css"],
        bodyClass: "document-editor",
        height: "5cm",
        allowedContent: true,
        exportPdf_options: {
            header_html: '<div class="styled">Header content</div>',
            footer_html: '<div class="styled"><span class="pageNumber"></span></div>',
            header_and_footer_css:
                ".styled { font-weight: bold; padding: 10px; text-align: center; color: red; }",
            margin_left: "1cm",
            margin_right: "2cm",
            format: "A5",
            page_orientation: "landscape",
        },
        protectedSource: [/{%[\s\S]*?%}+/g, /{{[\s\S]*?}}+/g],
      // Phones get a short toolbar; desktop keeps the full grouped one.
      ...compactToolbar(),
    };

    const loadServices = async () => {
        const response = await adminactions.loadServices();
        if (response) {
            setServices(response.data.results);
        }
    }

    useEffect(() => {
        loadServices();
    }, [])

    const onFinish = async (rawValues) => {
        const values = {
            ...rawValues,
            discount_type: rawValues.discount_type || null,
            discount_value: rawValues.discount_type ? rawValues.discount_value || 0 : 0,
        };
        if (instance) {
            const restOfTheServices = serviceData.filter((service) => service.id !== instance.id)
            setServiceData([...restOfTheServices, { ...values, invoice: inventoryId, item_type: "SERVICE" }])
            reload();
        } else {
            setServiceData((serviceData) => [...serviceData, { ...values, invoice: inventoryId, item_type: "SERVICE", id: new Date().valueOf() }])
            reload();
        }
    };

    const onChange = (tax_rate_1 = 0, tax_rate_2 = 0, tax_rate_3 = 0) => {
        console.log(tax_rate_1, tax_rate_2, tax_rate_3)
        setTaxRate1(tax_rate_1)
        setTaxRate2(tax_rate_2)
        setTaxRate3(tax_rate_3)
        form.setFieldValue("line_total", discountedLineTotal(
            form.getFieldValue("quantity"),
            form.getFieldValue("price"),
            form.getFieldValue("discount_type"),
            form.getFieldValue("discount_value"),
            [tax_rate_1, tax_rate_2, tax_rate_3]
        ));
    }

    useEffect(() => {
        if (instance) {
            setServiceDescription(instance.description);
            setIsFixedRate(instance.is_fixed_rate);
            form.setFieldsValue({
                ...instance,
                discount_type: instance.discount_type || undefined,
                discount_value: instance.discount_value || undefined,
            });
        } else {
            // Reset to default when switching to add mode
            setServiceDescription("<p>Create your Template here!</p>");
            setIsFixedRate(false);
        }
    }, [instance])

    return (
        <Form
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 18 }}
            onFinish={onFinish}
        >
            <Row style={{ margin: "15px" }}>
                <Col span={24}>
                    <div className="site-card-border-less-wrapper">
                        <div>
                            <Form.Item
                                label="Item"
                                name="item"
                                rules={[
                                    {
                                        required: true,
                                        message: `Please Input title!`
                                    }
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select Service"
                                    optionFilterProp="children"
                                    allowClear
                                    onChange={(value) => {
                                        const service = services.find(item => item.title === value);
                                        setServiceDescription(service.notes)
                                        form.setFieldsValue({ "title": service.title, "description": service.notes, "price": service.price, "unit": service.unit, "hsn": service.hsn, "quantity": service.quantity });
                                        onChange(taxRate1, taxRate2, taxRate3);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={services.map((item, index) => {
                                        return { value: item.title, label: item.title }
                                    })}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Title"
                                name="title"
                                rules={[
                                    {
                                        required: true,
                                        message: `Please Input title!`
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item label="Description" name="description"
                                getValueFromEvent={(event) => {
                                    const data = event.editor.getData();
                                    return data;
                                }}
                            >
                                {instance ? (
                                    <CKEditor
                                        key={`edit-${instance.id}`}
                                        initData={instance.description}
                                        config={editorConfig}
                                        editorUrl={process.env.REACT_APP_BASE_URL + "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"}
                                    />
                                ) : (
                                    <CKEditor
                                        key="new-service"
                                        initData={serviceDescription}
                                        config={editorConfig}
                                        editorUrl={process.env.REACT_APP_BASE_URL + "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label="HSN/SAC" name="hsn">
                                <Input />
                            </Form.Item>
                            <Form.Item label="Is Fixed Rate" name='is_fixed_rate' valuePropName="checked">
                                <Switch
                                    onChange={value => {
                                        setIsFixedRate(value);
                                        form.setFieldValue("quantity", 1);
                                        onChange(taxRate1, taxRate2, taxRate3);
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Unit" name="unit">
                                <Select
                                    showSearch
                                    placeholder="Select Unit"
                                    options={[
                                        { value: "DAYS", label: "DAYS" },
                                        { value: "HOURS", label: "HOURS" },
                                    ]}
                                />
                            </Form.Item>
                            <Form.Item label="Rate" type="number" name="price">
                                <InputNumber
                                    onChange={(value) => {
                                        if (value) {
                                            onChange(taxRate1, taxRate2, taxRate3)
                                            // const price = form.getFieldValue("price");
                                            // const quantity = form.getFieldValue("quantity");
                                            // form.setFieldValue("line_total", quantity * price);
                                        }
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Quantity" type="number" name="quantity">
                                <InputNumber
                                    onChange={(value) => {
                                        if (value) {
                                            onChange(taxRate1, taxRate2, taxRate3)
                                            // const price = form.getFieldValue("price");
                                            // const quantity = form.getFieldValue("quantity");
                                            // form.setFieldValue("line_total", quantity * price);
                                        }
                                    }}
                                    disabled={isFixedRate ? true : false}
                                />
                            </Form.Item>
                            <Form.Item label="Discount Type" name="discount_type">
                                <Select
                                    placeholder="No discount"
                                    allowClear
                                    options={DISCOUNT_TYPE_OPTIONS}
                                    onChange={(value) => {
                                        if (!value) {
                                            form.setFieldValue("discount_value", undefined);
                                        }
                                        onChange(taxRate1, taxRate2, taxRate3);
                                    }}
                                />
                            </Form.Item>
                            <Form.Item noStyle dependencies={["discount_type"]}>
                                {({ getFieldValue }) =>
                                    getFieldValue("discount_type") ? (
                                        <Form.Item
                                            label="Discount"
                                            name="discount_value"
                                            rules={[{ required: true, message: "Please enter the discount!" }]}
                                        >
                                            <InputNumber
                                                min={0}
                                                max={getFieldValue("discount_type") === "PERCENT" ? 100 : undefined}
                                                step={0.01}
                                                precision={2}
                                                addonAfter={getFieldValue("discount_type") === "PERCENT" ? "%" : undefined}
                                                onChange={() => onChange(taxRate1, taxRate2, taxRate3)}
                                            />
                                        </Form.Item>
                                    ) : null
                                }
                            </Form.Item>
                            <Form.Item label="Tax Rate 1" name="tax_rate1">
                                <Select
                                    showSearch
                                    placeholder="Select Tax Rate"
                                    allowClear
                                    onChange={(value) => {
                                        const taxRate = taxRates.find(item => item.id === value);
                                        if (taxRate) {
                                            onChange(taxRate.rate / 100, taxRate2, taxRate3)
                                        } else {
                                            onChange(0, taxRate2, taxRate3)
                                        }
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={taxRates?.map((item, index) => {
                                        return { value: item.id, label: `${item.title + " " + item.rate} %` }
                                    })}
                                />
                            </Form.Item>
                            <Form.Item label="Tax Rate 2" name="tax_rate2">
                                <Select
                                    showSearch
                                    placeholder="Select Tax Rate"
                                    allowClear
                                    onChange={(value) => {
                                        const taxRate = taxRates.find(item => item.id === value);
                                        if (taxRate) {
                                            onChange(taxRate1, taxRate.rate / 100, taxRate3)
                                        } else {
                                            onChange(taxRate1, 0, taxRate3)
                                        }
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={taxRates?.map((item, index) => {
                                        return { value: item.id, label: `${item.title + " " + item.rate} %` }
                                    })}
                                />
                            </Form.Item>
                            <Form.Item label="Tax Rate 3" name="tax_rate3">
                                <Select
                                    showSearch
                                    placeholder="Select Tax Rate"
                                    allowClear
                                    onChange={(value) => {
                                        const taxRate = taxRates.find(item => item.id === value);
                                        if (taxRate) {
                                            onChange(taxRate1, taxRate2, taxRate.rate / 100)
                                        } else {
                                            onChange(taxRate1, taxRate2, 0)
                                        }
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    options={taxRates?.map((item, index) => {
                                        return { value: item.id, label: `${item.title + " " + item.rate} %` }
                                    })}
                                />
                            </Form.Item>
                            <Form.Item label="Line Total" name="line_total">
                                <Input disabled />
                            </Form.Item>
                        </div>
                        <Flex justify='flex-end'>
                            <Button block type="primary" htmlType="submit" style={{ maxWidth: 100 }} >
                                Save
                            </Button>
                        </Flex>
                    </div>
                </Col>
            </Row>
        </Form>
    );
};

export default InvoiceServiceForm;